import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Home from "../pages/home";
import AboutUs from "../pages/about-us";
import ContactUs from "../pages/contact-us";
import Terms from "../pages/terms";
import Faq from "../pages/faq";
import Buybitcoin from "../pages/buybitcoin";
import Referral from "../pages/referral";
import Guid from "../pages/guid";
import GuidSections from "../pages/guid-sections";
import EasySellBuy from "../pages/easysellbuy";
import WithoutSidebarPages from "../components/WithoutSidebarPages";
import { DownloadApplication } from "../components/compound/DownloadApplication/DownloadApplication";
import UserLevel from "../pages/user-level";
import Markets from "../pages/markets";
import Privacy from "../pages/privacy";
import CurrencyDetail from "../components/compound/currencydetail/currencydetail";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <WithoutSidebarPages />,
        children: [
          {
            path: "/",
            element: <Home />,
          },
          {
            path: "/about-us",
            element: <AboutUs />,
          },
          {
            path: "/contact-us",
            element: <ContactUs />,
          },
          {
            path: "/terms",
            element: <Terms />,
          },
          {
            path: "/privacy",
            element: <Privacy />,
          },
          {
            path: "/faq",
            element: <Faq />,
          },
          {
            path: "/buy/bitcoin",
            element: <Buybitcoin />,
          },
          {
            path: "/referral",
            element: <Referral />,
          },
          {
            path: "/guid",
            element: <Guid />,
          },
          {
            path: "/guid-sections",
            element: <GuidSections />,
          },
          {
            path: "/easy-sell-and-buy",
            element: <EasySellBuy />,
          },
          {
            path: "/download-application",
            element: <DownloadApplication />,
          },
          {
            path: "/user-level",
            element: <UserLevel />,
          },
          {
            path: "/markets",
            element: <Markets />,
          },
          { path: "/currency/:id", element: <CurrencyDetail /> },
        ],
      },
    ],
  },
]);

export default router;
